const attributionKey = (key: string) =>
  /^utm_[a-zA-Z0-9_]+$/.test(key) || ["fbclid", "_fbc", "_fbp", "meta_ad_id"].includes(key);

export function gruiaAttributionMetadata(value: unknown): Record<string, string> {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const result: Record<string, string> = {};
  for (const [key, entry] of Object.entries(value)) {
    if (attributionKey(key) && typeof entry === "string") result[key] = entry;
  }
  return result;
}

export function mergeGruiaAttribution(query: URLSearchParams, metadata: Record<string, string> = {}) {
  const result = { ...metadata };
  query.forEach((value, key) => {
    if (attributionKey(key) && !Object.prototype.hasOwnProperty.call(result, key)) result[key] = value;
  });
  return result;
}
